import { styled } from '@mui/material';

import Page from '@/components/Page/index.ts';
import { getActiveCompetition, competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage2';
import { Disclaimer } from './_components/Disclaimer.tsx';
import { Footer } from './_sections/Footer.tsx';
import { RulesSection } from './_sections/RulesSection.tsx';
import { StatsSection } from './_sections/StatsSection.tsx';
import { TimerSection2 } from './_sections/TimerSection2.tsx';
import { TopSection2 } from './_sections/TopSection2.tsx';
import { WinnersSection } from './_sections/WinnersSection.tsx';

const Root = styled('div')({
  width: '100%',
  backgroundColor: 'white',
});

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const competition = competitions.find((c) => c.slug === 'wake_up_2024_campaign_2');
  const allWinners = [...competitions].reverse().flatMap((c) => c.winners);
  return {
    winners: competition?.winners,
    activeCompetition: await getActiveCompetition(competitions),
    allWinners,
  };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Høstkampanje">
      <Root>
        <TopSection2
          winners={loaderData.winners}
          activeCompetition={loaderData.activeCompetition}
        />
        <Disclaimer />
        <TimerSection2 activeCompetition={loaderData.activeCompetition} />
        <WinnersSection allWinners={loaderData.allWinners} />
        <RulesSection activeCompetition={loaderData.activeCompetition} />
        <StatsSection activeCompetition={loaderData.activeCompetition} />
        <Footer />
      </Root>
    </Page>
  );
}
